import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/HomeNews.css';

function HomeNews() {
  // Updated data structure: sources is now an array
  const featuredNews = [
    {
      id: 1,
      title: `Wilbert Ross Cover Story Filmed at Victoria Sports Club`,
      excerpt: "There’s something different about Wilbert Ross and you don’t need to look twice to feel it...",
      img: "/vscimages/news/wilbert.png",
      date: "April 10, 2026",
      // Array of multiple sources
      sources: [
        { name: "Village Pipol", url: "https://villagepipol.com/wilbert-ross-a-perfect-time-to-be-seen/" },
      ]
    },
    {
      id: 2,
      title: `“Babae Ako” event, Tampok ang inspirasyon ng kababaihan`,
      excerpt: "Celebrated the success and inspiration of women at the Women’s Month event in Quezon City...",
      img: "/vscimages/news/babaeako.jpg",
      date: "April 4, 2026",
      // Array of multiple sources
      sources: [
        { name: "Net25 News & Information", url: "https://www.facebook.com/share/v/1GPwkwVLtg/" },
      ]
    },
    // {
    //   id: 2,
    //   title: "Love Starts Within, Grows With Community: A Lifestyle Celebration at Victoria Sports Club",
    //   excerpt: "That spirit came alive at “Stay Lucky in Love,” recently held at Victoria Sports Club and VS Hotel Convention Center...",
    //   img: "/vscimages/news/village.jpg",
    //   date: "February 14, 2026",
    //   // Array of multiple sources
    //   sources: [
    //     { name: "VillagePipol", url: "https://villagepipol.com/love-starts-within-grows-with-community-a-lifestyle-celebration-at-victoria-sports-club-and-vs-hotel-convention-center/" },
    //   ]
    // }
    
  ];

  return (
    <section id="home-news" className="home-news-section">
      <div className="home-news-container">
        
        <div className="homenews-header">
          <div className="homeheader-text">
            <span>Stay Updated</span>
            <h2>Latest From Victoria Sports</h2>
          </div>
          <Link to="/news" className="view-all-desktop">
            View All News 
          </Link>
        </div>

        <div className="news-list">
          {featuredNews.map((news) => (
            <div className="news-row-card" key={news.id} data-aos="fade-up">
              <div className="news-img-box">
                <img src={news.img} alt={news.title} />
                <span className="news-cat-tag">{news.date}</span>
              </div>
              
              <div className="news-content-box">
                <h3>{news.title}</h3>
                <p className="news-excerpt">{news.excerpt}</p>
                
                {/* MULTI-SOURCE LINK SECTION */}
                <div className="home-news-links">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-container">
                    {news.sources.map((src, index) => (
                      <React.Fragment key={index}>
                        <a href={src.url} target='_blank' rel='noreferrer' className="source-link">
                          {src.name}
                        </a>
                        {/* Add separator except for the last item */}
                        {index < news.sources.length - 1 && <span className="separator">|</span>}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mobile-view-all">
            <Link to="/news" className="view-all-btn-mobile">See All News</Link>
        </div>

      </div>
    </section>
  );
}

export default HomeNews;




// import React from 'react';
// import { Link } from 'react-router-dom';
// import '../../styles/HomeNews.css';

// function HomeNews() {
//   // Mock data - You can import your real newsData here
//   const featuredNews = [
//     {
//       id: 1,
//       source: "VILLAGEPIPOL",
//       title: "Love Starts Within, Grows With Community: A Lifestyle Celebration at Victoria Sports Club and VS Hotel Convention Center",
//       excerpt: "That spirit came alive at “Stay Lucky in Love,” recently held at Victoria Sports Club and VS Hotel Convention Center...",
//       img: "/vscimages/news/village.jpg",
//       date: "February 14, 2026",
//       link: "https://villagepipol.com/love-starts-within-grows-with-community-a-lifestyle-celebration-at-victoria-sports-club-and-vs-hotel-convention-center/"
//     },
//     {
//       id: 2,
//       source: "EXTRAVEL.PH",
//       title: "Victory Run 2025 Delivers Star Power, Purpose, and Pure Community Energy",
//       excerpt: "Dr. Isic also shared that Victoria Sports Club continues to elevate its lifestyle offerings, including a private and exclusive cinema now screening box office movies from Metro Manila Film Festival...",
//       img: "/vscimages/news/gm.jpg",
//       date: "Dec 24, 2025",
//       link: "https://www.exptravelph.com/post/victory-run-2025-delivers-star-power-purpose-and-pure-community-energy?fbclid=IwY2xjawPdCWpleHRuA2FlbQIxMQBzcnRjBmFwcF9pZBAyMjIwMzkxNzg4MjAwODkyAAEeqKvTZzXI1Lrt0GGm9a56haCv1QGbEIR9a_UYcwOIHd0j8SVqo4ZCqmSrorw_aem_dpkcaAku7aD7rjF0Rq25Yw"
//     }
//   ];

//   return (
//     <section id="home-news" className="home-news-section">
//       <div className="home-news-container">
        
//         <div className="homenews-header">
//           <div className="homeheader-text">
//             <span>Stay Updated</span>
//             <h2>Latest From Victoria Sports</h2>
//           </div>
//           <Link to="/news" className="view-all-desktop">
//             View All News 
//           </Link>
//         </div>

//         <div className="news-list">
//           {featuredNews.map((news) => (
//             <div className="news-row-card" key={news.id} data-aos="fade-up">
//               <div className="news-img-box">
//                 <img src={news.img} alt={news.title} />
//                 <span className="news-cat-tag">{news.date}</span>
//               </div>
              
//               <div className="news-content-box">
//                 <p className="news-source">{news.source}</p>
//                 <h3>{news.title}</h3>
//                 <p className="news-excerpt">{news.excerpt}</p>
//                 <a href={news.link} target='_blank' rel='noreferrer' className="read-more-link">
//                   Read More
//                 </a>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="mobile-view-all">
//            <Link to="/news" className="view-all-btn-mobile">See All News</Link>
//         </div>

//       </div>
//     </section>
//   );
// }

// export default HomeNews;